import { parseDate } from "@lyfegen-platform/utils";
import { format } from "date-fns";
import { TrFun } from "./types";

export function getMinAssessmentDate(
	lastCBAssessmentDate?: Date | string | null | undefined,
	irDate?: Date | string | null | undefined,
	crDate?: Date | string | null | undefined,
	lastPrescriptionDate?: Date | string | null | undefined
) {
	if (lastPrescriptionDate) {
		return parseDate(lastPrescriptionDate);
	}

	if (lastCBAssessmentDate) {
		return parseDate(lastCBAssessmentDate);
	}

	if (irDate) {
		return parseDate(irDate);
	}

	if (crDate) {
		return parseDate(crDate);
	}

	return parseDate("2000-01-01");
}

export function getMinDateMessage(
	translate: TrFun,
	lastCBAssessmentDate?: Date | string | null | undefined,
	irDate?: Date | string | null | undefined,
	crDate?: Date | string | null | undefined,
	lastPrescriptionDate?: Date | string | null | undefined
) {
	if (lastPrescriptionDate)
		return `${translate("must-be-after-last-prescription-date")} - ${format(parseDate(lastPrescriptionDate) as Date, "dd.MM.yyyy")}`;
	if (lastCBAssessmentDate)
		return `${translate("must-be-after-cb-date")} - ${format(parseDate(lastCBAssessmentDate) as Date, "dd.MM.yyyy")}`;
	if (irDate) return `${translate("must-be-after-ir-date")} - ${format(parseDate(irDate) as Date, "dd.MM.yyyy")}`;
	if (crDate) return `${translate("must-be-after-cr-date")} - ${format(parseDate(crDate) as Date, "dd.MM.yyyy")}`;
	return translate("invalid-date");
}
